export enum ModulesType {
    PRODUCTCONFIG = 'Product Configuration',
    CONFIGURATION = 'Unit Configuration',
    MINEINSIGHTS = 'Mine Insights',
    PLANNING = 'Planning',
    OPERATIONCONTROL = 'Operations Control',
    MAINTENANCE = 'Maintenance',
    DRILLBLAST = 'Drill & Blast',
    GRADECONTROL = 'Grade Control',
    MINEOPTIMIZATION = 'Mine Optimization',
    OVERVIEW = "Overview",
    SAP = "Sap",
    DIAGNOSTICS = "Diagnostics",
}